import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

// Global loading state - simple module-level state
let loadingState = {
  isLoading: false,
  count: 0 // Track multiple simultaneous requests
};

// Listeners for loading state changes
const listeners = new Set();

const notifyListeners = () => {
  listeners.forEach(listener => listener(loadingState));
};

// Global function to show loading spinner
export const showLoading = () => {
  loadingState = {
    ...loadingState,
    count: loadingState.count + 1,
    isLoading: true
  };
  notifyListeners();
};

// Global function to hide loading spinner
export const hideLoading = () => {
  const newCount = Math.max(0, loadingState.count - 1);
  loadingState = {
    ...loadingState,
    count: newCount,
    isLoading: newCount > 0
  };
  notifyListeners();
};

const GlobalLoader = () => {
  const [state, setState] = useState(loadingState);

  useEffect(() => {
    const listener = (newState) => {
      setState({ ...newState });
    };
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  if (!state.isLoading) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none">
      {/* Backdrop */}
      <div className="absolute inset-0 pointer-events-auto" />
      
      {/* Spinner */}
      <div className="relative flex flex-col items-center gap-3">
        <Loader2 className="h-10 w-10 text-primary animate-spin" />
      </div>
    </div>
  );
};

export default GlobalLoader;

